exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-install-js": () => import("./../../../src/templates/install.js" /* webpackChunkName: "component---src-templates-install-js" */),
  "component---src-templates-language-js": () => import("./../../../src/templates/language.js" /* webpackChunkName: "component---src-templates-language-js" */)
}

